import React from 'react';
import { Check } from 'lucide-react';
import { classNames } from '@/lib/format';

// stages: [{ code, label, status: 'complete' | 'pending' | 'upcoming' }]
// Palette: blue = done, amber = started/pending, grey = not started.
export const PipelineTimeline = ({ stages, compact = false }) => {
  return (
    <ol data-testid="pipeline-timeline" className={classNames('flex items-center gap-2 overflow-x-auto', compact && 'text-xs')}>
      {stages.map((s, i) => {
        const isComplete = s.status === 'complete';
        const isPending = s.status === 'pending';
        const dot = isComplete
          ? 'bg-primary text-primary-foreground'
          : isPending
            ? 'bg-amber-400 text-amber-950 ring-4 ring-amber-400/25'
            : 'bg-slate-200 text-slate-500';
        const labelCls = isComplete || isPending
          ? 'text-foreground'
          : 'text-muted-foreground';
        return (
          <React.Fragment key={`${s.code}-${i}`}>
            <li className="flex shrink-0 items-center gap-2">
              <span
                className={classNames('grid h-6 w-6 place-items-center rounded-full text-[10px] font-semibold', dot)}
                data-testid={`pipeline-timeline-dot-${i}`}
                data-status={s.status}
              >
                {isComplete ? <Check className="h-3 w-3" /> : i + 1}
              </span>
              <span className={classNames('text-xs font-medium', labelCls)}>{s.label}</span>
            </li>
            {i < stages.length - 1 && <span className="h-px w-6 shrink-0 bg-border" />}
          </React.Fragment>
        );
      })}
    </ol>
  );
};
